// @flow

import React from 'react';
import { connect } from 'react-redux';
import { getUiSetting, setUiSetting } from '@leasen_nl/listo/src/store/uiStore';
import Cart from '@leasen_nl/listo/src/components/cart';
import { getSaveCompositionForm } from '@leasen_nl/listo/src/store/routes/selectors';
import { SaveConfigModal, SAVE_CONFIG_MODAL_OPEN } from './atoms';


type StateProps = {|
  isOpen: boolean,
  saveCompositionForm: any,
|};

type DispatchProps = {|
  closeModal: Function,
  openModal: Function,
|};

type Props = {|
  ...StateProps,
  ...DispatchProps,
|};

const EnrichedCart = ({
  closeModal,
  isOpen,
  saveCompositionForm,
  openModal,
  ...otherCartProps
}: Props) => (
  <div>
    <Cart
      showSave={Boolean(saveCompositionForm)}
      onSave={() => openModal()}
      {...otherCartProps}
    />
    {saveCompositionForm && (
      <SaveConfigModal
        isOpen={isOpen}
        saveCompositionForm={saveCompositionForm}
        closeModal={() => closeModal()}
      />
    )}
  </div>
);

const mapStateToProps = (state: any): StateProps => ({
  isOpen: Boolean(getUiSetting(state, SAVE_CONFIG_MODAL_OPEN)),
  saveCompositionForm: getSaveCompositionForm(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  closeModal: () => dispatch(setUiSetting(SAVE_CONFIG_MODAL_OPEN, false)),
  openModal: () => dispatch(setUiSetting(SAVE_CONFIG_MODAL_OPEN, true)),
});

export default connect<Props, any, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(EnrichedCart);
